<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    :modal="showBackdrop"
    custom-class="manage-subscription-modal"
    data-test="modal-managesubscription"
    @closed="emitEvent"
  >
    <div
      class="manage-subscription"
      data-test="modal-subscription"
    >
      <h4 class="heading">
        Manage Subscription
      </h4>
      <div
        v-if="!isSubscribed || isCanceled"
        class="upgrade-section"
      >
        <h4>Upgrade to premium</h4>
        <div>Ad-free listening experience and access to exclusive podcasts</div>
        <el-button
          v-if="!isSubscribed || isCanceled"
          type="primary"
          class="cta"
          data-test="btn-gopremium"
          @click="openUpgradeModel"
        >
          <span
            v-if="(subscriptionStatus === 'Free' && !isSubscribed && !isCanceled)">Start a
            <span
              v-if="promoMeta.trialPeriod > 1"
              class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} free trial!</span>
          <span
            v-else>Go premium</span>
        </el-button>
        <div>
          {{ userDefaultPricing.price | amountFilter(userDefaultPricing.currency) }}
          {{ userDefaultPricing.price || '0.0' | taxFilter(subscription.currency) }}
        </div>
      </div>
      <div class="current-plan-section">
        <el-row>
          <el-col
            :md="8"
            :sm="8"
            :xs="12"
          >
            <div class="section">
              <div>Current</div>
              <div v-if="currentSubscriptionStatus">
                <h5 v-if="currentSubscriptionStatus === 'FREE TRIAL'">Free Trial</h5>
                <h5 v-if="currentSubscriptionStatus === 'PREMIUM'">Premium</h5>
                <h5 v-if="currentSubscriptionStatus === 'FREE'">Free</h5>
              </div>
              <h5 v-else>
                Free
              </h5>
              <div
                v-if="(
                ((subscriptionStatus === 'Free' && isSubscribed)
                || (isSubscribed && isCanceled))
                && !isTrialEnded)"
                class="small-text">Free Trial</div>
            </div>
          </el-col>
          <el-col
            :md="8"
            :sm="8"
            :xs="12"
          >
            <div class="section">
              <div>Price</div>
              <h5>{{ subscription.final_price || '0.0' | amountFilter(subscription.currency || userDefaultPricing.currency) }}</h5>
              <!-- <div class="small-text">{{ subscription.final_price || '0.0' | taxFilter(subscription.currency) }}</div> -->
            </div>
          </el-col>
        </el-row>
        <el-row
          v-if="isCardExpired"
          class="custom-error-alert"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <el-row
            type="flex"
            align="middle">
            <i class="el-icon-warning" />
            <span>Your credit card has an invalid expiration date</span>
          </el-row>
          <div
            class="action"
            @click="openUpgradeModel()">Update Now</div>
        </el-row>
        <div class="access-details">
          <div v-if="!isSubscribed">
            All app features without access to premium shows.
          </div>
          <div v-else>
            Ad-free listening experience and access to exclusive podcasts
          </div>
        </div>
      </div>
      <div
        v-if="isSubscribed && !isCanceled"
        class="downgrad-section"
      >
        <h5>Free</h5>
        <div class="access-details">
          All app features without access to premium shows.
        </div>
        <el-button
          class="btn-transparent switch-free"
          data-test="btn-downgrade"
          @click="openDowngradeModel"
        >
          Switch to free
        </el-button>
      </div>
    </div>
    <adyen-unsubscribe-modal
      :show_modal="showAdyenDowngradeModel"
      @close="closeDowngradeModel"
    />
    <adyen-modal
      :show_modal="showAdyenUpgradeModel"
      :update_payment="updatePaymentInfo"
      @close="closeUpgradeModel"
    />
  </el-dialog>
</template>
<script>
import UpdatePaymentInfo from './UpdatePaymentInfo';
import AdyenUnsubscribeModal from './DowngradeModal';
import AdyenSubscriptionModal from './UpgradeModal';

export default {
  name: 'ManageSubscriptionModal',
  components: {
    'update-payment-info': UpdatePaymentInfo,
    'adyen-unsubscribe-modal': AdyenUnsubscribeModal,
    'adyen-modal': AdyenSubscriptionModal,
  },
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
    updatePayment: {
      default: false,
      type: Boolean,
    },
    transaction: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: this.show_modal,
      showPaymentForm: false,
      showAdyenDowngradeModel: false,
      showAdyenUpgradeModel: false,
      updatePaymentInfo: false,
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user && this.$store.getters.user.is_subscribed;
    },
    isCanceled() {
      return this.$store.getters.userSubscription && this.$store.getters.userSubscription.is_cancelled;
    },
    subscription() {
      return this.$store.getters.userSubscription || {};
    },
    currentSubscriptionStatus() {
      const { userSubscription } = this.$store.getters;

      if (userSubscription) {
        return userSubscription.subscription_status;
      }

      return '';
    },
    subscriptionStatus() {
      let status = 'Free';
      if (this.subscription && this.subscription.trial_end_date) {
        const currentDate = new Date();
        const trialEndDate = new Date(this.subscription.trial_end_date);
        if (currentDate.getTime() >= trialEndDate.getTime()) {
          status = 'Premium';
        }
      }
      return status;
    },
    // remainingDays() {
    //   const currentDate = new Date();
    //   const nDate = this.subscription.trial_end_date || this.subscription.expire_at;
    //   const nextdate = nDate ? new Date(nDate) : new Date();
    //   const diff = nextdate.getTime() - currentDate.getTime();
    //   let totalDays = (((diff / 1000) / 60) / 60) / 24;
    //   if (totalDays) {
    //     totalDays = Math.floor(totalDays);
    //   }
    //   return `${totalDays} ${totalDays === 1 ? 'day' : 'days'}`;
    // },
    userDefaultPricing() {
      return this.$store.getters.pricing;
    },
    showBackdrop() {
      const width = window.innerWidth;
      return width > 567;
    },
    isTrialEnded() {
      let isTrialEnded = false;
      const trialEndDate = this.subscription.trial_end_date ? new Date(this.subscription.trial_end_date) : null;
      const currentDate = new Date();
      if (!trialEndDate) {
        isTrialEnded = true;
      } else if (trialEndDate && trialEndDate < currentDate) {
        isTrialEnded = true;
      }
      return isTrialEnded;
    },
    currentPaymentMethod() {
      return this.transaction;
    },
    isCardExpired() {
      let flag = false;
      const currentDate = new Date();
      if (this.currentPaymentMethod && this.currentPaymentMethod.card_expiry) {
        const cardExpiry = this.currentPaymentMethod.card_expiry.split('/'); // api send date in format like: 1/2023
        const expiryMonth = parseInt(cardExpiry[0], 10);
        const expiryYear = parseInt(cardExpiry[1], 10);
        if (expiryYear < currentDate.getFullYear()) {
          flag = true;
        } else if ((expiryYear === currentDate.getFullYear()) && (expiryMonth < (currentDate.getMonth() + 1))) {
          flag = true;
        }
      }
      return flag;
    },
  },
  watch: {
    show_modal(newVal) {
      this.showModal = newVal;
    },
  },
  methods: {
    emitEvent(flag) {
      this.$emit('close', flag);
    },
    openDowngradeModel() {
      this.showAdyenDowngradeModel = true;
    },
    closeDowngradeModel(canceled) {
      this.showAdyenDowngradeModel = false;
      if (canceled) {
        this.emitEvent(true, 'downgrade');
      }
    },
    openUpgradeModel() {
      if (this.isCanceled && this.isSubscribed) {
        this.updatePaymentInfo = true;
      }
      // this.showAdyenUpgradeModel = true;
      this.$emit('openUpgradeModal', this.updatePaymentInfo);
    },
    closeUpgradeModel(success) {
      // this.showAdyenUpgradeModel = false;
      if (success) {
        this.emitEvent(true, 'upgrade');
      }
    },
  },
};
</script>
<style lang="scss">
.manage-subscription-modal.el-dialog{
  .el-dialog__body{
    padding: 53px 61px;
  }
  .manage-subscription{
    .heading,h4 {
      font-family: "ITC Clearface";
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 28px;
      margin-top: 0;
      color: #111111;
    }
    p {
      font-size: 16px;
      color: #111111;
      line-height: 20px;
    }
    h5{
      color: #111111;
    }
    .action-button {
      font-size: 16px;
      line-height: 20px;
      font-weight: normal;
    }
    .upgrade-section{
      border: 2px solid #D4D4D4;
      border-radius: 6px;
      padding: 31px 46px;
      color: #666666;
      h4{
        margin-bottom: 16px;
      }
      .cta{
        margin-top: 26px;
        margin-bottom: 6px;
      }
    }
    .current-plan-section{
      background-color: #fbfafa;
      border: 2px solid #00AECB;
      border-radius: 6px;
      padding: 24px 46px;
      margin-top: 20px;
      h5{
        color: #111111;
        margin-top: 8px;
        margin-bottom: 8px;
      }
      .section > div{
        margin-top: 0px;
        margin-bottom: 10px;
      }
      .section > div:first-child{
        font-size: 14px;
        color: #666666;
      }
      .custom-error-alert {
        padding: 8px 16px !important;
        background-color: #fef0f0;
        border: 1px solid #f56c6c !important;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 14px !important;
        line-height: 18px;
        margin-bottom: 8px;
        .el-icon-warning{
          color: #f56c6c;
          font-size: 24px;
          margin-right: 6px;
        }
        .action {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }
    .downgrad-section{
      border: 1px solid #D4D4D4;
      border-radius: 6px;
      padding: 31px 46px;
      margin-top: 20px;
      .switch-free{
        border-color: #111111;
        margin-top: 24px;
      }
      h5{
        margin: 16px 0;
      }
    }
  }
}
@media (max-width: 567px) {
  .manage-subscription-modal.el-dialog{
    border: 0px;
    border-radius: 0px;
    margin-top: 72px !important;
    height: auto;
    min-height: 100vh;
    margin-bottom: 0px;
    .el-dialog__body{
      padding: 21px 4px;
    }
    .manage-subscription{
      .heading,h4 {
        margin-left: 32px;
      }
      .upgrade-section{
        padding: 24px 32px;
      }
      .current-plan-section{
        padding: 24px 32px;
      }
      .downgrad-section{
        padding: 24px 32px;
      }
    }
    // .current-plan{
    //   .el-row > div:first-child {
    //     max-width: 30%;
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/ManageSubscriptionModal.vue